import type { Stage } from './useStage';
import useStage from './useStage';

export default function useMinimumStage(minimumStage: Stage) {
  const stage = useStage();
  if (level[stage] === undefined) {
    throw new Error(
      `Unknown site stage value '${stage}'. Please use one of these values: ${Object.keys(
        level
      ).join(', ')}.`
    );
  }
  return level[stage] >= level[minimumStage];
}

const level = {
  HIDE_ALL_PRODUCTS: 0,
  SHOW_PRODUCTS: 1,
  SHOW_FINALISTS: 2,
  SHOW_WINNERS: 3,
};
